import { useEffect, useState } from 'react';
import { useOfflineStatus } from '../../hooks/useOfflineStatus';
import './OfflineBanner.css';

const OfflineBanner = () => {
  const { isOffline, isUsingCache } = useOfflineStatus();
  const [showBanner, setShowBanner] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    if (isOffline || isUsingCache) {
      setShowBanner(true);
      if (isOffline) setWasOffline(true);
    } else if (wasOffline && !isOffline) {
      // Mostrar mensaje "Back online" por 3 segundos
      setTimeout(() => {
        setShowBanner(false);
        setWasOffline(false);
      }, 3000);
    } else {
      setShowBanner(false);
    }
  }, [isOffline, isUsingCache, wasOffline]);

  if (!showBanner) return null;

  const isBackOnline = wasOffline && !isOffline && !isUsingCache;

  return (
    <div className={`offline-banner ${isOffline || isUsingCache ? 'offline' : 'online'}`}>
      <div className="offline-banner-content">
        {isBackOnline ? (
          <>
            <svg className="online-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            </svg>
            <div className="offline-text">
              <strong>Back online</strong>
              <span>Your connection has been restored.</span>
            </div>
          </>
        ) : (
          <>
            <svg className="offline-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 9L12 2L23 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M5 12.55L12 8L19 12.55" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 16L12 14L15 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="2" y1="22" x2="22" y2="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <div className="offline-text">
              <strong>{isOffline ? 'No internet connection' : 'Limited connectivity'}</strong>
              <span>You&apos;re viewing cached content. Some information may be outdated.</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OfflineBanner;
